import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function Control() {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const controlItems = [
    {
      id: 1,
      icon: "bi-info-circle",
      text: t("control.about"),
      path: "/admin/home/aboutus",
    },
    {
      id: 2,
      icon: "bi-chat-left-dots",
      text: t("control.comments"),
      path: "/admin/home/comments",
    },
    {
      id: 3,
      icon: "bi-gear-wide-connected",
      text: t("control.mobileSettings"),
      path: "/admin/home/payment",
    },
    {
      id: 4,
      icon: "bi-phone",
      text: t("control.mobileControl"),
      path: "/admin/home/mobile-update",
    },
  ];

  const handleItemClick = (item) => {
    navigate(item.path);
  };

  return (
    <div className="admin-main p-2">
      <div className="d-flex align-items-center justify-content-between mb-2">
        <div className="d-flex gap-2 align-items-center">
          <button className="btn btn-light" onClick={() => navigate(-1)}>
            <i className="bi bi-chevron-left"></i>
          </button>
          <button className="btn btn-light" onClick={() => navigate(+1)}>
            <i className="bi bi-chevron-right"></i>
          </button>
          <h5 className="fw-bold">{t("sazlamalar")}</h5>
        </div>
      </div>

      <div className="row row-cols-1 row-cols-sm-2 row-cols-md-2 row-cols-xl-4 g-2">
        {controlItems.length > 0 ? (
          controlItems.map((item) => (
            <div className="col" key={item.id}>
              <div
                className="card h-100 border-0 rounded-3 dashboard-card"
                style={{ cursor: "pointer" }}
                onClick={() => handleItemClick(item)}
              >
                <div className="card-body d-flex align-items-center p-4">
                  <i
                    className={`bi ${item.icon} fs-2 me-3 text-secondary`}
                  ></i>
                  <span className="fw-medium">{item.text}</span>
                </div>
              </div>
            </div>
          ))
        ) : (
          <div className="col-12 text-center text-muted">
            {t("control.noPermissions")}
          </div>
        )}
      </div>
    </div>
  );
}
